
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

@Component()
export default class CurationCard extends Vue {
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly keyword: string
  @Prop({ required: true })readonly description: string
  @Prop({ required: true })readonly subject: string
  @Prop({ required: true })readonly intention: string
  @Prop({ required: true })readonly level: string
  @Prop({ required: true })readonly category: string

  data () {
    return {
      isNewTaskModalOpen: false,
      isLoading: false
    }
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  approve () {
    this.$emit('approve', this.id)
  }

  reprove () {
    this.$emit('reprove', this.id)
  }
}
